<p-drawer [(visible)]="showPosBillingSidebar" [showCloseIcon]="false" position="right" [blockScroll]="true" styleClass="w-full payment-sidebar no-header" [dismissible]="false" [closeOnEscape]="false" (onHide)="closeBillingSideBar('')">
  <ng-template #headless>
  <form [formGroup]="fg" class="p-sidebar-content__wrapper flex flex-column justify-content-between">
      <!-- Content -->
      <div>
          <!-- Header -->
          <div class="border-bottom-1 border-300 relative flex align-items-center">
              <div (click)="closeBillingSideBar('')" class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center" [attr.aria-label]="'close-pos-billing-sidebar'" [attr.data-testid]="'close-pos-billing-sidebar'">
                  <i class="fa fa-times text-xl text-600"></i>
              </div>
              <div class="flex align-items-center ml-3">
                  <h4 class="flex align-items-center mb-0 mr-3 text-base font-bold">
                      <i class="fa fa-cart-shopping text-500 mr-3"></i>
                      <span class="text-base">
                          {{'POS.MEMBERSHIP_ADDON.BILL_SUMMARY' | translate}}
                      </span>
                  </h4>
              </div>
          </div>
          <!-- Header -->

          <div class="md:pt-3 pt-2 md:px-4 px-3 pb-8" *ngIf="!hasbillingRights">
              <div class="flex justify-content-between">
                  <h1 class="text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
                      {{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}
                      <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer ml-2" pTooltip="{{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}" tooltipStyleClass="text-xs" [attr.aria-label]="'pos-charges-info'" [attr.data-testid]="'pos-charges-info'"></i>
                  </h1>

                  <div>
                      <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}" icon="fa fa-lock" styleClass="text-sm hidden md:flex" (click)="RequestAccess()" [attr.aria-label]="'request-access-button'" [attr.data-testid]="'request-access-button'"> </p-button>
                      <p-button icon="fa fa-lock" styleClass="text-sm md:hidden" [attr.aria-label]="'request-access-button-mobile'" [attr.data-testid]="'request-access-button-mobile'"></p-button>
                  </div>
              </div>

              <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3" />

              <!-- Card -->
              <div class="surface-0 shadow-2 pb-6">
                  <p-message severity="error" icon="fa fa-times" aria-label="access-denied-message">
                      {{ 'POS.MEMBERSHIP_ADDON.YOU_DONT_HAVEACCESS' | translate }}
                  </p-message>

                  <div class="text-center mt-6">
                      <img src="/assets/img/no-data-img.svg" alt="Request Access" />
                      <br />

                      <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}" icon="fa fa-lock" styleClass="text-sm mt-5" (click)="RequestAccess()"></p-button>
                  </div>
              </div>
              <!-- Card -->
          </div>

          <div *ngIf="hasbillingRights">
              <div *ngIf="posDetails$ | async as planSummary;" class="flex px-3 pb-2 pt-3 align-items-center justify-content-between">
                  <div class="flex align-items-center">
                      <div class="h-2rem w-2rem">
                          <p-avatar *ngIf="planSummary.client.client_image; else noContactPic" [image]="planSummary.client.client_image" shape="circle"></p-avatar>
                          <ng-template #noContactPic>
                              <p-avatar [label]="planSummary.client.client_name | titlecase | shortName" shape="circle"></p-avatar>
                          </ng-template>
                      </div>
                      <h3 class="mb-0 ml-2 md:-mt-1">
                          <div>
                              <a href="../client/profile/{{ planSummary.client.client_id }}" class="text-primary text-base mr-2 font-bold border-bottom-1 border-white hover:border-primary" [attr.aria-label]="'client-profile-link'" [attr.data-testid]="'client-profile-link'">
                                  {{ planSummary.client.client_name }}
                              </a>
                              <div class="position-absolute text-xs text-600 mb-0 w-9 white-space-nowrap text-overflow-ellipsis" *ngIf="billingNameFormControl.value">
                                  <strong>
                                      {{ 'POS.MEMBERSHIP_ADDON.BILLING_NAME' | translate }}:
                                  </strong>
                                  {{billingNameFormControl.value}} <span class="fa fa-times text-xl text-600 cursor-pointer" (click)="removeBillingName()" [attr.aria-label]="'remove-billing-name-button'" [attr.data-testid]="'remove-billing-name-button'"> </span>
                              </div>
                          </div>
                          <span class="text-600 font-normal text-sm">
                              {{'common.DATA.CLIENT_ID' | translate}} - {{planSummary.client.client_id}}
                          </span>
                      </h3>
                  </div>
                  <!-- <div [innerHTML]="clientStatus( planSummary.client)"></div> -->
                  <div class="flex align-items-center justify-content-end">
                      <!-- <span class="bg-pink-500 px-2 py-1 line-height-3 font-bold border-round text-white text-xxs mr-1">ENQUIRY</span> -->
                      <div [innerHTML]="clientStatus( planSummary.client)"></div>
                      <button
                          pButton
                          pRipple
                          type="button"
                          icon="fa fa-ellipsis-h"
                          class="surface-0 p-button-outlined border-300 ml-2 md:ml-3 text-xs md:text-sm p-1 md:p-2 h-2rem w-2rem text-600"
                          (click)="action.toggle($event)"
                          [attr.aria-label]="'client-actions-menu-button'"
                          [attr.data-testid]="'client-actions-menu-button'">
                        </button>
                      <p-popover #action styleClass="overflow-hidden right-0 text-sm w-10rem -ml-3">
                          <ng-template #content>
                              <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
                                  <li class="cursor-pointer hover:surface-300 p-3 flex align-items-center" (click)="changeBillingName=true">
                                      <i class="fa fa-user-edit text-xs mr-2"></i>{{'POS.MEMBERSHIP_ADDON.EDIT_BILLING_NAME' | translate}}
                                  </li>
                              </ul>
                          </ng-template>
                      </p-popover>
                  </div>
              </div>

              <div class="shadow-2 border-round p-3 mx-3 my-2">
                  <ng-container *ngIf="chargeMasterList$ | async as obj; else templateB">
                      <p-select
                          *ngIf="disableChargeMasterDropdown"
                          [options]="chargeMasterList$ | async"
                          formControlName="ddlplanSubscriptionList"
                          optionLabel="name_primary_language"
                          filterBy="name_primary_language"
                          [filter]="true"
                          styleClass="w-full text-sm"
                          placeholder="{{'POS.MEMBERSHIP_ADDON.SELECT_PRODUCT' | translate}}"
                          [attr.aria-label]="'select-product-dropdown'"
                          [attr.data-testid]="'select-product-dropdown'">
                          <ng-template pTemplate="selectedItem">
                              <div class="flex align-items-center text-xs md:text-sm" *ngIf="planList">
                                  <span class="bg-blue-50 uppercase px-2 py-1 border-round text-primary border-1 border-primary text-xxs">
                                      {{'POS.PLANTYPE.' + planList.value.subscription_category.toUpperCase() | translate }}
                                  </span>
                                  <span class="mx-2">
                                      {{authService.getLocalizedFieldData(planList.value.name_primary_language,planList.value.name_secondary_language) | async}}
                                  </span>
                                  <strong>
                                      {{getPlanAmount(planList.value) | currencyformat}}
                                  </strong>
                              </div>
                          </ng-template>
                          <ng-template let-memberships pTemplate="item">
                              <div class="flex align-items-center text-xxs md:text-sm" [attr.data-testid]="'membership-item-'+memberships.name_primary_language" [attr.aria-label]="'membership-item-'+memberships.name_primary_language">
                                  <span class="bg-blue-50 uppercase px-2 py-1 border-round text-primary border-1 border-primary text-xxs">
                                      {{'POS.PLANTYPE.' + memberships.subscription_category.toUpperCase() | translate }}
                                  </span>
                                  <span
                                      class="mx-2 w-8rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
                                      pTooltip="{{authService.getLocalizedFieldData(memberships.name_primary_language,memberships.name_secondary_language) | async}}"
                                      tooltipStyleClass="text-xs">
                                      {{authService.getLocalizedFieldData(memberships.name_primary_language,memberships.name_secondary_language) | async}}
                                  </span>
                                  <strong>
                                      {{getPlanAmount(memberships) | currencyformat}}
                                  </strong>
                              </div>
                          </ng-template>
                      </p-select>
                  </ng-container>
                  <ng-template #templateB>
                      <div class="skeleton">
                          <p-skeleton styleClass="mb-2"></p-skeleton>
                      </div>
                  </ng-template>

                  <ng-container *ngIf="(chargeMaster$ | async) as obj; else templateA">
                      <div class="flex justify-content-between mt-3 mb-2">
                          <div>
                              <h3 *ngIf="!disableChargeMasterDropdown" class="text-base font-bold mb-2">
                                  {{ authService.getLocalizedFieldData(obj.name_primary_language,obj.name_secondary_language) | async}}
                              </h3>
                              <p class="text-xs text-600 mb-0">
                                  {{authService.getLocalizedFieldData(obj.description_primary_language,obj.description_secondary_language) | async}}
                              </p>
                          </div>
                          <div class="white-space-nowrap ml-4 text-lg text-right">
                              <strong class="text-lg block line-height-1" *ngIf="totalOneTimeCost$ | async as totalOneTimeCost">
                                  {{totalOneTimeCost | currencyformat}}
                              </strong>
                              <i class="block text-600 text-xxs">
                                  {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}
                              </i>
                          </div>
                      </div>

                      <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none m-0" />
                  </ng-container>

                  <ng-template #templateA>
                      <div class="skeleton" *ngIf="subscriptionPlanId > 0">
                          <br />
                          <p-skeleton styleClass="mb-2"></p-skeleton>
                          <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
                          <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
                          <p-skeleton height="2rem" styleClass="mb-2"></p-skeleton>
                          <p-skeleton width="10rem" height="4rem"></p-skeleton>
                      </div>
                  </ng-template>
              </div>

              <!-- Info Card -->

              <!-- Mid Part -->
              <div class="surface-50 p-3 border-top-1 border-300 mt-3 ng-tns-c274-0">
                  <!-- Bill Details -->
                  <div class="mt-3 md:mt-4">
                      <h5 class="text-sm mb-2">{{'POS.MEMBERSHIP_ADDON.BILLDETAILS' | translate}}</h5>
                      <ng-container *ngIf="(planBreakUpCalculation$ | async) as billingBreakup; else templateC">
                          <!-- {{oJSON.stringify(billingBreakup)}} -->
                          <div *ngIf="!applyDiscount" class="border-1 border-300 border-round text-sm surface-0">
                              <ng-container *ngFor="let charges of billingBreakup.charging_today.signup_charges">
                                  <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer" [attr.data-testid]="'signup-charge-'+charges.name_primary_language" [attr.aria-label]="'signup-charge-'+charges.name_primary_language">
                                      <span>{{charges.name_primary_language}}</span>
                                      <span>
                                          {{ getChargeNetCost(charges) | currencyformat}}
                                      </span>
                                  </div>
                              </ng-container>
                              <ng-container *ngIf="!isInclusive">
                                  <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer">
                                      <div class="cursor-pointer text-primary flex align-items-center" tooltipStyleClass="text-xs" tooltipPosition="top">
                                          <span class="mr-2">{{'POS.MEMBERSHIP_ADDON.TAXES' | translate}}</span><i class="fa fa-info-circle text-lg text-500 cursor-pointer" [attr.aria-label]="'taxes-info-icon'" [attr.data-testid]="'taxes-info-icon'"></i>
                                      </div>
                                      <span>
                                          {{ getTotalTaxAmount(billingBreakup.charging_today.service_first_charge && billingBreakup.charging_today.service_first_charge.services ? billingBreakup.charging_today.service_first_charge.services: []) + getTotalTaxAmount(billingBreakup.charging_today.service_non_recurring && billingBreakup.charging_today.service_non_recurring.services ? billingBreakup.charging_today.service_non_recurring.services : []) +
                                          getTotalChargeTaxAmount(billingBreakup.charging_today.signup_charges) | currencyformat }}
                                      </span>
                                  </div>
                              </ng-container>
                              <div *ngIf="!discountApplied" class="px-3 py-2 flex align-items-center justify-content-between">
                                  <p-button (click)="ApplyDiscount(true)" label="{{'POS.MEMBERSHIP_ADDON.APPLY_DISCOUNT' | translate}}" class="text-xs" styleClass="text-primary surface-0 py-1 border-400" [attr.aria-label]="'apply-discount-button'"> </p-button>
                              </div>
                              <div *ngIf="discountApplied" class="px-3 py-2 flex align-items-center justify-content-between">
                                  <p-button (click)="ApplyDiscount(true)" label="{{'POS.MEMBERSHIP_ADDON.EDIT_DISCOUNT' | translate}}" class="text-xs" styleClass="text-primary surface-0 py-1 border-400" [attr.aria-label]="'edit-discount-button'"> </p-button>
                                  <button
                                      (click)="discountApplied=false;RemoveDiscount()"
                                      pButton
                                      type="button"
                                      icon="fa fa-times text-xl-circle"
                                      label="{{'POS.MEMBERSHIP_ADDON.REMOVE_DISCOUNT' | translate}}"
                                      class="text-xs p-button-text -mr-3"
                                      [attr.aria-label]="'remove-discount-button'"
                                      [attr.data-testid]="'remove-discount-button'">
                                    </button>
                              </div>
                              <div class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom mt-2">
                                  <span>{{'POS.MEMBERSHIP_ADDON.GRAND_TOTAL' | translate}}</span>
                                  <span class="text-right" *ngIf="totalOneTimeCost$ | async as totalOneTimeCost">
                                      {{totalOneTimeCost | currencyformat}}
                                  </span>
                              </div>
                          </div>
                          <!-- Discount Area -->
                          <div *ngIf="applyDiscount">
                              <div [formGroup]="fgProducts">
                                  <div class="border-1 border-300 border-round text-sm surface-0">
                                      <div class="px-3 py-2 flex align-items-center justify-content-between">
                                          <strong class="flex align-items-center">{{'POS.MEMBERSHIP_ADDON.ONE_TIME_DISCOUNT'| translate}} </strong>
                                      </div>
                                      <!-- <div *ngFor="let controls of charges.controls; let n=index"> -->
                                      <div formArrayName="charges" class="servicechargecontainer_edit" *ngFor="let charges of (planBreakUpCalculation$ | async)?.charging_today?.signup_charges;let n=index">
                                          <div [formGroupName]="0" class="px-3 py-2 flex align-items-center justify-content-between" [attr.data-testid]="'charge-discount-header-'+charges.name_primary_language" [attr.aria-label]="'charge-discount-header-'+charges.name_primary_language">
                                              <span>{{charges.name_primary_language}}</span>
                                              <div class="flex align-items-center">
                                                  <span>{{charges.amount_in_minor_currency | currencyformat}}</span>
                                                  <p-inputNumber
                                                      [minFractionDigits]="2"
                                                      [maxFractionDigits]="4"
                                                      [formControlName]='"charges_"+charges.id'
                                                      styleClass="w-4rem h-2rem mx-2 text-sm ng-invalid ng-dirty"
                                                      inputStyleClass="px-1"
                                                      (onBlur)="calculateChargeDiscount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                                      [attr.aria-label]="'charge-amount-input-'+charges.name_primary_language"
                                                      [attr.data-testid]="'charge-amount-input-'+charges.name_primary_language">
                                                  </p-inputNumber>
                                                  <div class="p-inputgroup">
                                                      <span class="p-inputgroup-addon">%</span>
                                                      <p-inputNumber
                                                          [formControlName]='"discount_"+charges.id'
                                                          [minFractionDigits]="2"
                                                          [maxFractionDigits]="4"
                                                          mode="decimal"
                                                          styleClass="w-3rem -ml-1 px-0 text-sm"
                                                          inputStyleClass="px-1"
                                                          (onBlur)="calculateChargeAmount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                                          [attr.aria-label]="'charge-discount-input-'+charges.name_primary_language"
                                                          [attr.data-testid]="'charge-discount-input-'+charges.name_primary_language">
                                                      </p-inputNumber>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>

                                      <div class="p-3 border-top-1 border-300">
                                          <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate}}</label>
                                          <textarea pInputTextarea formControlName="charges_reason" class="w-full h-4rem" placeholder="" [attr.aria-label]="'discount-reason-textarea'" [attr.data-testid]="'discount-reason-textarea'"></textarea>
                                          <app-error-msg *ngIf="ChargesDiscountReason.touched && ChargesDiscountReason.invalid" [errors]="ChargesDiscountReason.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate">
                                          </app-error-msg>
                                      </div>

                                      <div class="px-3 flex justify-content-end" *ngIf="inValidDiscount">
                                          <p-message severity="error" icon="fa fa-exclamation-triangle" styleClass="-mt-3 -mb-2" aria-label="invalid-discount-message">
                                              {{ 'POS.MEMBERSHIP_ADDON.YOUCANNOTAPPLY' | translate }} {{ userDiscountLimit }} % {{ 'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate }}
                                          </p-message>
                                      </div>
                                  </div>
                              </div>
                              <div class="flex align-items-center justify-content-between mt-3">
                                  <button (click)="StaffDiscountCancel();" pButton type="button" label="{{'common.PLACEHOLDER.CANCEL' | translate}}" class="text-sm p-button-text" [attr.aria-label]="'cancel-discount-button'" [attr.data-testid]="'cancel-discount-button'"></button>
                                  <button (click)="StaffDiscountBreakup()" pButton type="button" label="{{'common.PLACEHOLDER.APPLY' | translate}}" class="text-sm" [attr.aria-label]="'apply-discount-button'" [attr.data-testid]="'apply-discount-button'"></button>
                              </div>
                          </div>
                          <!-- Discount Area -->
                      </ng-container>
                      <ng-template #templateC>
                          <div class="border-1 border-300 border-round text-sm surface-0 font-bold p-5 text-center">
                              <div>{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}</div>
                              <img src="/assets/img/empty-favorite-img.svg" title="{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}" />
                          </div>
                      </ng-template>
                  </div>
                  <!-- Bill Details -->

                  <!-- Details -->

                  <!-- Details -->
              </div>
              <!-- Mid Part -->
              <div class="surface-0 px-3 py-2 flex justify-content-between flex-wrap border-top-1 border-300 mt-3">
                  <div class="w-12 md:w-6 my-3">
                      <h5 class="font-medium text-700 text-xs mb-2 md:mb-3 block uppercase">
                          {{'POS.MEMBERSHIP_ADDON.BILL_DATE' | translate}}
                      </h5>
                      <!-- <strong class="text-base">{{this.billDate.value | datetimeformat:'usformat'}}</strong> -->
                      <p-datepicker
                          [showIcon]="true"
                          formControlName="billdate"
                          [readonlyInput]="true"
                          placeholder="{{'common.PLACEHOLDER.SELECT_DATE' | translate}}"
                          inputStyleClass="text-sm"
                          styleClass="w-full"
                          [maxDate]="maxStartDate"
                          [minDate]="minStartDate"
                          [attr.aria-label]="'bill-date-calendar'"
                          [attr.data-testid]="'bill-date-calendar'">
                      </p-datepicker>
                  </div>

                  <div class="w-12 md:w-6 mt-3 md:pl-2">
                      <h5 class="font-medium text-700 text-xs mb-2 md:mb-3 block uppercase">
                          {{'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate}}
                      </h5>
                      <staff-selector
                          [formGroup]="fg"
                          [controlName]="billingOwner"
                          [id]="_selectedstaff"
                          [styleClass]="'w-full text-sm py-0 align-items-center'"
                          [placeHolder]="'CreateEditStaff.SELECT_PLACEHOLDER' | translate"
                          [filterstaff]="_filterStaff"
                          [attr.aria-label]="'bill-owner-selector'"
                          [attr.data-testid]="'bill-owner-selector'">
                      </staff-selector>
                      <app-error-msg *ngIf="billingOwner.dirty && billingOwner.invalid" [errors]="billingOwner.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate"> </app-error-msg>
                  </div>

                  <!-- Bill Owner and Date -->
              </div>
          </div>
      </div>
      <!-- Content -->

      <!-- Bottom Part -->
      <div *ngIf="hasbillingRights" class="sticky bottom-0 right-0 w-full text-center p-3 surface-400 shadow-3 z-5">
          <div class="relative mx-auto">
              <p-button [loading]="isSubmitting" styleClass="w-full justify-content-center align-items-center p-0" [attr.aria-label]="'continue-other-payment-button'" [attr.data-testid]="'continue-other-payment-button'">
                  <div class="flex align-items-center mr-3 p-3 w-full" (click)="OpenOfflinePayment()">
                      <strong class="p-button-label ml-2">{{'POS.MEMBERSHIP_ADDON.CONTINUE_OTHER_PAYMENT' | translate}}</strong>
                  </div>
              </p-button>
          </div>
      </div>
      <!-- Bottom Part -->
  </form>
  </ng-template>
</p-drawer>

<!-- Change Billing Name Modal  -->
<p-dialog [(visible)]="changeBillingName" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <form [formGroup]="billingNameForm">
          <!-- Header -->
          <div class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300">
              <h2 class="mb-0 text-sm">{{'POS.MEMBERSHIP_ADDON.CHANGE_BILLING_NAME' | translate}}</h2>
              <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="changeBillingName = false"></div>
          </div>
          <!-- Header -->

          <!-- Modal Content -->
          <div class="surface-100 border-bottom-1 border-300 p-3">
              <!-- Column -->
              <label class="font-medium text-700 text-xs mb-2 block uppercase"> {{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}</label>
              <input type="text" class="text-sm w-full" formControlName="billing_name" pInputText placeholder="Enter the new billing name" [attr.aria-label]="'billing-name-input'" [attr.data-testid]="'billing-name-input'"/>
              <app-error-msg *ngIf="billingNameFormControl.dirty && billingNameFormControl.invalid" [errors]="billingNameFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate"> </app-error-msg>
              <!-- Column -->
          </div>
          <!-- Modal Content -->

          <!-- Modal Footer -->
          <div class="surface-0 border-top-1 border-300 p-3">
              <p-button [disabled]="billingNameFormControl.invalid" styleClass="w-full text-lg" label="{{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}" (click)="changeBillingName=false" [attr.aria-label]="'save-billing-name-button'" [attr.data-testid]="'save-billing-name-button'"></p-button>
          </div>
          <!-- Modal Footer -->
      </form>
  </ng-template>
</p-dialog>
<!-- Change Billing Name Modal  -->

<other-payment
  *ngIf="otherPaymentsModal$ | async"
  [otherPaymentsModal]="otherPaymentsModal$ | async"
  [creditBalance]="clientCreditBalance"
  [showCreditBalance]="true"
  [totalAmtTobePaid]="totalOneTimeCost$ | async"
  (hideOtherPaymentDialog)="HideOtherPaymentDialog($event)"
  (closeOtherPaymentDialog)="closeOtherPaymentDialog($event)"
>
</other-payment>

<app-errors *ngIf="showErrorPopup | async as showPopup" [error]="error" [visible]="showPopup" [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)"> </app-errors>
